<template>
  <v-container
    class="products-list-page"
    fluid>
    <v-row>
      <v-col cols="4">
        <v-row
          class="elevation-3 rounded products-row"
          style="height: 100%;">
          <v-col cols="12">
            <side-bar
              :products="products"
              :fetching-product="gettingProducts"
              @add-product="addProductToSelected($event)"
              @search="getProducts($event)" />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        style="gap: 16px; overflow-y: auto; max-height: calc(100vh - 78px);"
        cols="8">
        <v-row
          class="elevation-0 rounded "
          style="height: 100%;">
          <v-col
            cols="12"
            class="pb-0">
            <div class="d-flex flex-row align-right products-row pa-4">
              <h2>RFID Generator</h2>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                class="mr-2"
                color="secondary"
                :loading="exporting"
                @click="dialogImport = true">
                IMPORT FILE
              </v-btn>
              <v-dialog
                v-model="dialogImport"
                max-width="500px"
                @click:outside="onCloseCsvDialog">
                <v-card>
                  <v-card-title>Upload a File</v-card-title>

                  <v-card-text class="pb-0">
                    <p>คำเตือนเมื่อทำการเลือกไฟล์และคอนเฟิร์มรายการที่เลือกไว้ก่อนหน้าจะหายไป</p>
                    <v-file-input
                      v-model="selectedFile"
                      label="Select CSV file"
                      accept=".csv"
                      color="secondary"
                      class="my-2"
                      outlined
                      dense
                      hide-details
                      @focus="clearValidate"
                      @change="validateCsvV2" />
                    <p
                      v-if="csvValidateErrors.length"
                      class="text-bold">
                      Total {{ csvValidateErrors.length }} errors.
                    </p>
                    <div
                      v-if="csvValidateErrors.length"
                      class="csv-fail">
                      <p
                        v-for="(errText, index) in csvValidateErrors"
                        :key="index"
                        class="red--text">
                        {{ errText }}
                      </p>
                    </div>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      @click="onCloseCsvDialog">
                      Close
                    </v-btn>
                    <v-btn
                      color="secondary"
                      :disabled="csvValidateErrors.length > 0"
                      @click="addProductFromCsvV2">
                      Confirm
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <!-- <v-divider class="my-4" /> -->
            <div
              v-if="skuNotFounds.length"
              class="products-row mt-4">
              <p
                class="text-bold red--text mx-4">
                รหัสสินค้าที่ไม่มีในระบบ {{ skuNotFounds.length }}
              </p>
              <v-card
                max-height="100"
                style="overflow: scroll;"
                outlined
                shaped
                tile
                class="pa-4 ma-4">
                <p
                  v-for="(skuNotFound, index) in skuNotFounds"
                  :key="index"
                  class="mb-2">
                  <span class="text-bold">{{ index+1 }}</span> : {{ skuNotFound.code }}
                  <span class="text-bold">จำนวน</span> : {{ skuNotFound.amount }}
                </p>
              </v-card>
            </div>
            <div
              v-if="incompleteProduct.length"
              class="d-flex flex-column products-row pa-4 mt-4">
              <div class="d-flex flex-row align-right mb-4">
                <p
                  class="text-bold red--text">
                  สินค้าที่ไม่มีข้อมูลประเทศที่ผลิต {{ incompleteProduct.length }} กรุณา Export ไฟล์เพื่อติดต่อทาง MER.
                </p>
                <v-spacer></v-spacer>
                <v-btn
                  color="secondary"
                  :loading="exporting"
                  :disabled="!incompleteProduct.length"
                  @click="onIncompleteExport()">
                  EXPORT
                </v-btn>
              </div>
              <ItemBox
                v-for="(p, i) in incompleteProduct"
                :key="`selected-${i}`"
                v-bind="p"
                :is-show-qty="false"
                :amount.sync="p.amount"
                :is-show-fit="isShowFit"
                @remove-item="removeIncompleteItem(i)" />
            </div>
            <div
              v-if="selectedProduct.length"
              class="d-flex flex-column products-row pa-4 mt-4">
              <div class="d-flex flex-row align-right mb-4">
                <p
                  class="text-bold">
                  สินค้าที่พร้อมปรินท์ label {{ selectedProduct.length }}
                </p>
                <v-spacer></v-spacer>
                <v-btn
                  color="secondary"
                  :loading="exporting"
                  :disabled="!selectedProduct.length"
                  @click="onExport()">
                  EXPORT
                </v-btn>
              </div>
              <ItemBox
                v-for="(p, i) in selectedProduct"
                :key="`selected-${i}`"
                v-bind="p"
                :amount.sync="p.amount"
                :is-show-fit="isShowFit"
                @remove-item="removeItem(i)" />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ExportToCsv } from 'export-to-csv'
import RFIDGenerator from '@/assets/js/RFIDGenerate'
import ConsumerTypes from '@/assets/js/ConsumerTypes'
import ProductProvider from '@/resources/ProductProvider'
import ExportCurrencyRatesProvider from '@/resources/ExportCurrencyRatesProvider'
import SideBar from '../components/sideBar.vue'
import ItemBox from '../components/itemBox.vue'
import { mapProductExportCurrencyPrice, showPriceLocale } from '@/assets/js/Currencies'
import ExportPriceConversionsProvider from '@/resources/ExportPriceConversionsProvider'
import PrototypeProvider from '@/resources/PrototypeProvider'

const ProductService = new ProductProvider()
const ExportCurrencyRatesService = new ExportCurrencyRatesProvider()
const fileReader = new FileReader()
const ExportPriceConversionsService = new ExportPriceConversionsProvider()
const PrototypeService = new PrototypeProvider()

export default {
  components: {
    SideBar,
    ItemBox
  },
  data () {
    return {
      gettingProducts: false,
      exporting: false,
      selectedProduct: [],
      products: [],
      webUrl: {
        GW: 'https://www.gentlewomanonline.com',
        LW: 'https://www.gentlewomanonline.com',
        GU: 'https://www.gentlewomanonline.com',
        MM: 'https://matter-makers.com'
      },
      masterHeaderCsv: [
        'code',
        'amount'
      ],
      dialogImport: false,
      selectedFile: null,
      csvValidateErrors: [],
      skuNotFounds: [],
      query: {
        sortBy: 'createdAt',
        sortOrder: 'asc'
      },
      currenciesItems: [],
      conversionPrices: [],
      showPriceLocale,
      incompleteProduct: [],
      sortCurrencies: [
        'SGD',
        'MYR',
        'IDR'
      ]
    }
  },
  computed: {
    ...mapGetters({
      store: 'Store/store'
    }),
    isShowFit () {
      return this.store?.id === '645a1d00765d5519beeb97f6'
    }
  },
  async mounted () {
    await this.initMasterData()
    await this.getProducts()
  },
  methods: {
    ...mapActions({
      setErrorPage: 'Components/setErrorPage',
      setSnackbar: 'Components/setSnackbar'
    }),
    async getProducts (search = '') {
      if (this.gettingProducts) {
        return
      }

      try {
        this.gettingProducts = true

        const { data } = await ProductService.getProducts({ search })
        this.products = this.mappingSkus(data.results)
      } catch (error) {
        console.error('getting product', error)
        this.setErrorPage(error.code)
      } finally {
        this.gettingProducts = false
      }
    },
    mappingSkus (products) {
      const allSkus = []
      products.forEach((product) => {
        const tempSkus = product.skus.map((sku) => ({
          ...sku,
          name: product.name,
          model: product.model,
          collection: product.gwCollection,
          prototypeCategory: product.productPrototype?.category || 'UNKNOWN',
          prototypeId: product.productPrototype?.id || null,
          tags: product.tags
        }))

        allSkus.push(...tempSkus)
      })

      return allSkus.map((sku) => {
        const currencies = this.currenciesItems.map((c) => mapProductExportCurrencyPrice(sku, c, 10, this.conversionPrices))
        return {
          aliasId: +sku.aliasId,
          code: sku.code,
          name: sku.name,
          collection: sku.collection?.nickname ? sku.collection?.nickname : 'COLLECTION : -',
          prototypeCategory: sku.prototypeCategory,
          prototypeId: sku.prototypeId,
          size: sku.size?.name || '',
          color: sku.color?.name || '',
          price: sku.price,
          images: sku.images,
          fitting: this.getFittingText(sku.tags),
          currencies
        }
      })
    },
    getFittingText (tags) {
      if (this.isShowFit) {
        if (tags && tags.length) {
          const fittingTag = tags.find((tag) => ['UNISEX', 'WOMEN', 'KIDS', 'MEN'].includes(tag.toUpperCase()))
          if (fittingTag) {
            return fittingTag.toUpperCase()
          }
        }
        return 'FIT : -'
      }
      return ''
    },
    initOptions (size, color) {
      let option = ''

      if (size.name && color.name) {
        option = `${size.name.toUpperCase()} • ${color.name}`
      } else if (size.name && !color.name) {
        option = size.name.toUpperCase()
      } else if (!size.name && color.name) {
        option = color.name
      }

      return option
    },
    addAmount (index) {
      this.selectedProduct[index].amount++
    },
    removeAmount (index) {
      if (this.selectedProduct[index].amount > 1) {
        this.selectedProduct[index].amount--
      }
    },
    avoidNullValue (object, properties, defaultValue = '-') {
      return object[properties] || defaultValue
    },
    isNumberString (str) {
      return /^\d+$/.test(str)
    },
    isMonthYearString (str) {
      const regex = /^(0[1-9]|1[0-2])-\d{4}$/
      return regex.test(str)
    },
    onCloseCsvDialog () {
      this.dialogImport = false
      this.clearValidate()
    },
    clearValidate () {
      this.selectedFile = null
      this.csvValidateErrors = []
    },
    areArraysEqual (arr1, arr2) {
      if (arr1.length !== arr2.length) return false
      const sorted1 = [...arr1].sort()
      const sorted2 = [...arr2].sort()
      return sorted1.every((val, index) => val === sorted2[index])
    },
    findDuplicates (arr) {
      return arr.filter((item, index) => arr.indexOf(item) !== index)
    },
    validateCsv () {
      this.csvValidateErrors = []
      if (!this.selectedFile) return
      fileReader.readAsText(this.selectedFile, 'utf8')
      fileReader.onload = async (readerEvent) => {
        try {
          const contents = readerEvent.target.result.split('\n')
          const elements = []
          contents.forEach((line) => {
            if (line.trim().length > 0) {
              const text = line
                .replaceAll('"', '')
                .replaceAll('\r', '')
                .split(',')
              if (!text.every((col) => col.trim() === '')) {
                elements.push(text)
              }
            }
          })
          if (!elements || !Array.isArray(elements) || !elements.length || elements.length === 1) {
            this.csvValidateErrors.push('The CSV contains no content. Please ensure the file has valid data.')
            return
          }

          const headerFields = elements[0].filter((h) => h)

          // คอลัมน์ไม่เกินแต่ field ไม่ถูก
          if (!this.areArraysEqual(this.masterHeaderCsv, headerFields)) {
            // เกินหาว่าอะไรเกิน
            const extraHeaders = headerFields.filter((h) => !this.masterHeaderCsv.includes(h))
            if (extraHeaders.length) {
              this.csvValidateErrors.push(
                `Header : The CSV contains more header fields than required: ${extraHeaders.join(', ')}. Please remove the extra fields`
              )
            }

            // ขาดหาว่าอะไรขาด
            const missingHeaders = this.masterHeaderCsv.filter((h) => !headerFields.includes(h))
            if (missingHeaders.length) {
              this.csvValidateErrors.push(`Header : Required headers are missing: ${missingHeaders.join(', ')}. Please add them.`)
            }

            // หาว่าอะไรซ้ำ
            const duplicateField = this.findDuplicates(headerFields)
            if (duplicateField.length) {
              this.csvValidateErrors.push(`Header : ${duplicateField.join(', ')} fields are duplicated`)
            }
            return
          }

          const addRowText = (existingText, newText) => `${existingText ? ', ' : ''} ${newText}`
          for (const [index, element] of elements.entries()) {
            if (index !== 0) {
              const productInfo = Object.fromEntries(headerFields.map((key, mapIndex) => [key, element[mapIndex]]))
              let rowFailMsg = ''
              if (!productInfo['price'] || !this.isNumberString(productInfo['price'])) {
                rowFailMsg += addRowText(rowFailMsg, 'price')
              }
              if (!productInfo['aliasId'] || !this.isNumberString(productInfo['aliasId'])) {
                rowFailMsg += addRowText(rowFailMsg, 'aliasId')
              }
              if (!productInfo['amount'] || !this.isNumberString(productInfo['amount'])) {
                rowFailMsg += addRowText(rowFailMsg, 'amount')
              }
              if (!productInfo['code']) rowFailMsg += addRowText(rowFailMsg, 'code')
              if (!productInfo['color']) rowFailMsg += addRowText(rowFailMsg, 'color')
              if (!productInfo['size']) rowFailMsg += addRowText(rowFailMsg, 'size')
              if (!productInfo['prototypeCategory']) rowFailMsg += addRowText(rowFailMsg, 'prototypeCategory')
              if (!productInfo['productionDate'] || !this.isMonthYearString(productInfo['productionDate'])) {
                rowFailMsg += addRowText(rowFailMsg, 'productionDate')
              }
              if (rowFailMsg) {
                rowFailMsg = `Row ${index + 1} : ${rowFailMsg} must be a valid \n`
                this.csvValidateErrors.push(rowFailMsg)
              }
            }
          }
        } catch (e) {
          this.csvValidateErrors.push('Something wrong on CSV validate')
        }
      }
    },
    async addProductToSelected (_product) {
      let manufacCountry = ''
      let sketchId = ''
      if (_product?.prototypeId) {
        const { data: prototypeInfo } = await PrototypeService.getPrototypeByIdWithoutCost(_product.prototypeId)
        if (prototypeInfo?.order?.manufacCountry) {
          manufacCountry = prototypeInfo?.order?.manufacCountry === 'malaysia' ? 'china' : prototypeInfo?.order?.manufacCountry
        }
        sketchId = prototypeInfo?.sketch?.sketchId || ''
      }
      if (this.isShowFit && _product.fitting === 'FIT : -') {
        this.setSnackbar({
          value: true,
          message: 'รายการสินค้านี้ไม่ได้ระบุ Fit กรุณาตรวจสอบ',
          type: 'error',
          timeout: 6000
        })
      }
      const subBrandCode = _product.code.split('.')?.[0]?.toUpperCase()
      const url = `${this.webUrl[subBrandCode]}/${_product.code}`
      const product = {
        ..._product,
        manufacCountry,
        sketchId,
        url,
        consumerType: ConsumerTypes(_product.prototypeCategory.toLowerCase()),
        productionDate: this.$dayjs().subtract(2, 'month').format('MM-YYYY')
      }

      if (!manufacCountry) {
        const duplicatedIncompleted = this.incompleteProduct.findIndex((selected) => selected.code === product.code)
        if (duplicatedIncompleted === -1) {
          this.incompleteProduct.push({ ...product, amount: 1 })
        }
      } else {
        const duplicated = this.selectedProduct.findIndex((selected) => selected.code === product.code)
        if (duplicated === -1) {
          this.selectedProduct.push({ ...product, amount: 1 })
        } else {
          this.selectedProduct[duplicated].amount++
        }
      }
    },
    removeItem (index) {
      this.selectedProduct.splice(index, 1)
    },
    removeIncompleteItem (index) {
      this.incompleteProduct.splice(index, 1)
    },
    async onExport () {
      try {
        this.exporting = true
        const mapped = this.selectedProduct.map((v) => {
          const thPrice = this.showPriceLocale(v.price, 'TH', 'THB')
          const currency = {
            price: thPrice.price,
            priceUnit: thPrice.currency,
            priceSymbol: '฿'
          }
          const sortedCurrencies = v.currencies
            .filter((c) => this.sortCurrencies.includes(c.currency))
            .sort((a, b) => this.sortCurrencies.indexOf(a.currency) - this.sortCurrencies.indexOf(b.currency))
          sortedCurrencies.forEach((c, index) => {
            const convertPrice = this.showPriceLocale(c.price, c.locale, c.currency)
            const mappingPrice = this.$options.filters.showNumberFormat(c.price)
            currency[`price${index + 1}`] = c.priceFromMapping ? mappingPrice : convertPrice.price
            currency[`price${index + 1}Unit`] = c.currency
            currency[`price${index + 1}Symbol`] = convertPrice.currency
          })
          return {
            aliasId: v.aliasId,
            amount: v.amount,
            code: v.code,
            collection: v.collection,
            color: v.color,
            size: v.size,
            url: v.url,
            consumerType: `${v.consumerType.en} / ${v.consumerType.th}`,
            productionDate: v.productionDate,
            fitting: v.fitting,
            producedAt: v.manufacCountry.toUpperCase(),
            sketchId: v.sketchId,
            ...currency
          }
        })
        const rfid = new RFIDGenerator(mapped)
        const generated = await rfid.generateWithBatch()
        const timeStringFormat = this.$dayjs().format('DD_MM_YYYY_HHmm')
        const options = {
          filename: `${this.store.uniqueCode}_RFID_${timeStringFormat}`,
          showLabels: true,
          useKeysAsHeaders: true
        }

        const csvExporter = new ExportToCsv(options)
        csvExporter.generateCsv(generated)
      } catch (error) {
        console.error('exportCsv', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.exporting = false
      }
    },
    async onIncompleteExport () {
      try {
        this.exporting = true
        const mapped = this.incompleteProduct.map((v) => ({
          code: v.code,
          collection: v.collection,
          color: v.color,
          size: v.size,
          url: v.prototypeId ? `${window.location.origin}/prototype/order/edit/${v.prototypeId}` : 'สินค้านี้ไม่มี prototype',
          remark: 'กรุณาระบุข้อมูลสถานที่ผลิต'
        }))

        const timeStringFormat = this.$dayjs().format('DD_MM_YYYY_HHmm')
        const options = {
          filename: `incomplete_product_${timeStringFormat}`,
          showLabels: true,
          useKeysAsHeaders: true
        }

        const csvExporter = new ExportToCsv(options)
        csvExporter.generateCsv(mapped)
      } catch (error) {
        console.error('exportCsv', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.exporting = false
      }
    },
    validateCsvV2 () {
      this.csvValidateErrors = []
      if (!this.selectedFile) return
      fileReader.readAsText(this.selectedFile, 'utf8')
      fileReader.onload = async (readerEvent) => {
        try {
          const contents = readerEvent.target.result.split('\n')
          const elements = []
          contents.forEach((line) => {
            if (line.trim().length > 0) {
              const text = line
                .replaceAll('"', '')
                .replaceAll('\r', '')
                .split(',')
              if (!text.every((col) => col.trim() === '')) {
                elements.push(text)
              }
            }
          })
          if (!elements || !Array.isArray(elements) || !elements.length || elements.length === 1) {
            this.csvValidateErrors.push('The CSV contains no content. Please ensure the file has valid data.')
            return
          }

          const headerFields = elements[0].filter((h) => h)

          // คอลัมน์ไม่เกินแต่ field ไม่ถูก
          if (!this.areArraysEqual(this.masterHeaderCsv, headerFields)) {
            // เกินหาว่าอะไรเกิน
            const extraHeaders = headerFields.filter((h) => !this.masterHeaderCsv.includes(h))
            if (extraHeaders.length) {
              this.csvValidateErrors.push(
                `Header : The CSV contains more header fields than required: ${extraHeaders.join(', ')}. Please remove the extra fields`
              )
            }

            // ขาดหาว่าอะไรขาด
            const missingHeaders = this.masterHeaderCsv.filter((h) => !headerFields.includes(h))
            if (missingHeaders.length) {
              this.csvValidateErrors.push(`Header : Required headers are missing: ${missingHeaders.join(', ')}. Please add them.`)
            }

            // หาว่าอะไรซ้ำ
            const duplicateField = this.findDuplicates(headerFields)
            if (duplicateField.length) {
              this.csvValidateErrors.push(`Header : ${duplicateField.join(', ')} fields are duplicated`)
            }
            return
          }

          const addRowText = (existingText, newText) => `${existingText ? ', ' : ''} ${newText}`
          for (const [index, element] of elements.entries()) {
            if (index !== 0) {
              const productInfo = Object.fromEntries(headerFields.map((key, mapIndex) => [key, element[mapIndex]]))
              let rowFailMsg = ''
              if (!productInfo['amount'] || !this.isNumberString(productInfo['amount']) || (Number(productInfo['amount']) <= 0)) {
                rowFailMsg += addRowText(rowFailMsg, 'amount')
              }
              if (!productInfo['code']) rowFailMsg += addRowText(rowFailMsg, 'code')
              if (rowFailMsg) {
                rowFailMsg = `Row ${index + 1} : ${rowFailMsg} must be a valid \n`
                this.csvValidateErrors.push(rowFailMsg)
              }
            }
          }
        } catch (e) {
          this.csvValidateErrors.push('Something wrong on CSV validate')
        }
      }
    },
    async addProductFromCsvV2 () {
      this.exporting = true
      if (!this.selectedFile) {
        this.setSnackbar({
          value: true,
          message: 'กรุณาเลือกไฟล์',
          type: 'error',
          timeout: 6000
        })
        this.exporting = false
        return
      }
      try {
        this.selectedProduct = []
        this.incompleteProduct = []
        this.skuNotFounds = []
        const skusFromCsv = []
        const dataFromCsv = []
        fileReader.readAsText(this.selectedFile, 'utf8')
        fileReader.onload = async (readerEvent) => {
          const contents = readerEvent.target.result.split('\n')
          contents.forEach((line) => {
            if (line.trim().length > 0) {
              const text = line
                .replaceAll('"', '')
                .replaceAll('\r', '')
                .split(',')
              if (!text.every((col) => col.trim() === '')) {
                dataFromCsv.push(text)
              }
            }
          })
          const csvHeaderAsArray = dataFromCsv[0]
          for (const [index, skuAsArray] of dataFromCsv.entries()) {
            if (index !== 0) {
              const skuInfo = Object.fromEntries(csvHeaderAsArray.map((key, mapIndex) => [key, skuAsArray[mapIndex]]))
              skusFromCsv.push(skuInfo)
            }
          }
          const skuCodes = skusFromCsv.map((sku) => sku.code)
          const { data: skus } = await ProductService.getSkusByCodes({ skuCodes })
          for (const skuFromCsv of skusFromCsv) {
            const skuInfo = skus.find((sku) => sku.code === skuFromCsv.code)
            if (skuInfo) {
              let manufacCountry = ''
              if (skuInfo?.productPrototype?.id) {
                // eslint-disable-next-line no-await-in-loop
                const { data: prototypeInfo } = await PrototypeService.getPrototypeByIdWithoutCost(skuInfo?.productPrototype?.id)
                if (prototypeInfo?.order?.manufacCountry) {
                  manufacCountry = prototypeInfo?.order?.manufacCountry === 'malaysia' ? 'china' : prototypeInfo?.order?.manufacCountry
                }
              }
              skuInfo['fitting'] = this.getFittingText(skuInfo.tags)
              skuInfo['price'] = Number(skuInfo['price'])
              skuInfo['aliasId'] = Number(skuInfo['aliasId'])
              skuInfo['amount'] = Number(skuFromCsv['amount'])
              skuInfo['images'] = skuInfo.images || []
              skuInfo['collection'] = skuInfo['collection'] ? skuInfo['collection'] : 'COLLECTION : -'
              const consumerType = skuInfo?.productPrototype?.category || 'UNKNOWN'
              const subBrandCode = skuInfo.code.split('.')?.[0]?.toUpperCase()
              const url = `${this.webUrl[subBrandCode]}/${skuInfo.code}`
              const sku = {
                ...skuInfo,
                url,
                consumerType: ConsumerTypes(consumerType.toLowerCase()),
                manufacCountry,
                currencies: null
              }
              sku.currencies = this.currenciesItems.map((c) => mapProductExportCurrencyPrice(sku, c, 10, this.conversionPrices))
              if (!manufacCountry) {
                const duplicatedIncompleted = this.incompleteProduct.findIndex((selected) => selected.code === sku.code)
                if (duplicatedIncompleted === -1) {
                  this.incompleteProduct.push({ ...sku, amount: 1 })
                }
              } else {
                const duplicated = this.selectedProduct.findIndex((selected) => selected.code === sku.code)
                if (duplicated === -1) {
                  this.selectedProduct.push({ ...sku })
                } else {
                  this.selectedProduct[duplicated].amount += skuInfo.amount
                }
              }
            } else {
              this.skuNotFounds.push(skuFromCsv)
            }
          }
        }
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: 'ไฟล์ไม่สามารถใช้งานได้กรุณาตรวจสอบ',
          type: 'error',
          timeout: 6000
        })
      } finally {
        this.exporting = false
      }
      this.dialogImport = false
      this.selectedFile = null
    },
    async initMasterData () {
      const [currenciesItems, conversionPrice] = await Promise.all([
        ExportCurrencyRatesService.getItems(this.query),
        ExportPriceConversionsService.getAllActiveItems(this.query)
      ])
      if (currenciesItems?.data) this.currenciesItems = currenciesItems?.data.filter((cur) => cur.displayCountryPriceInTag) || []
      if (conversionPrice?.data) this.conversionPrices = conversionPrice.data || []
    }
  }
}
</script>

<style scoped>
.rfid-table {
  height: calc(100vh - 190px);
}
.csv-fail {
  max-height: 200px;
  overflow-y: scroll;
}
</style>
